import { defineComponent as X, computed as s, useAttrs as Y, ref as B, createElementBlock as p, openBlock as w, normalizeStyle as k, normalizeClass as y, createElementVNode as g, createCommentVNode as Z, Fragment as N, renderList as A, mergeProps as M, toHandlers as ee } from "vue";
import { useThrottleFn as te } from "@vueuse/core";
import { omit as ae } from "../../utils/omit.js";
import { tw as n } from "../../utils/tailwind.js";
import { Multipliers as R } from "./SliderBase.constant.js";
import { getTrackSize as le, getTrackPosition as V, getTrackValue as F, getUpdatedValue as P, getClosestStep as U } from "./SliderBase.helpers.js";
const oe = { class: "relative flex h-32 items-center lg:h-24" }, se = ["disabled"], ne = ["aria-disabled", "aria-label", "aria-valuemax", "aria-valuemin", "aria-valuenow", "tabindex"], re = ["value"], be = /* @__PURE__ */ X({
  name: "RevSliderBase",
  inheritAttrs: !1,
  __name: "SliderBase",
  props: {
    disabled: { type: Boolean, default: !1 },
    keyboardStep: { default: 1 },
    label: {},
    max: {},
    min: { default: 0 },
    modelValue: {},
    showSteps: { type: Boolean, default: !1 },
    step: { default: 1 }
  },
  emits: ["update:modelValue"],
  setup(c, { emit: $ }) {
    const e = c, j = $, H = s(() => ae(Y(), ["class", "style"])), b = B(null), m = B([]), x = s(() => e.modelValue.length === 1), I = s(() => e.modelValue.join(","));
    function h(t) {
      j("update:modelValue", t);
    }
    function E(t, a) {
      if (a === "keyboard") {
        m.value[t]?.focus();
        return;
      }
      m.value[t]?.dispatchEvent(new Event("mousedown"));
      try {
        m.value[t]?.dispatchEvent(new TouchEvent("touchstart"));
      } catch {
      }
    }
    const K = s(() => {
      const [t, a] = x.value ? [e.min, e.modelValue[0]] : e.modelValue;
      return {
        left: V(t, e.min, e.max),
        width: le(t, a, e.min, e.max)
      };
    }), S = s(() => {
      const t = [];
      for (let a = e.min; a <= e.max; a += e.step)
        t.push(a);
      return t;
    }), W = s(
      () => S.value.map((t) => ({
        left: V(t, e.min, e.max)
      }))
    ), _ = s(() => e.disabled ? "-1" : "0"), q = s(() => e.modelValue.map((t, a) => {
      let r = 0, o = 0;
      const f = te((l) => {
        const i = F(
          l,
          r,
          o,
          e.min,
          e.max,
          e.step
        );
        T(i, "");
      }, 10), u = () => {
        r = 0, o = 0, document.removeEventListener("touchmove", f), document.removeEventListener("touchend", u), document.removeEventListener("mousemove", f), document.removeEventListener("mouseup", u);
      }, T = (l, i) => {
        if (!e.disabled) {
          if (x.value) {
            h([l]);
            return;
          }
          if (a === 0 && l > e.modelValue[1]) {
            u(), E(1, i), h([e.modelValue[1], l]);
            return;
          }
          if (a === 1 && l < e.modelValue[0]) {
            u(), E(0, i), h([l, e.modelValue[0]]);
            return;
          }
          h(P(e.modelValue, a, l));
        }
      }, z = (l) => {
        if (l.preventDefault(), !b.value)
          return;
        const { left: i, width: d } = b.value.getBoundingClientRect();
        r = i, o = d, "touches" in l ? (document.addEventListener("touchmove", f), document.addEventListener("touchend", u)) : (document.addEventListener("mousemove", f), document.addEventListener("mouseup", u)), m.value[a]?.focus();
      };
      return {
        listeners: {
          keydown: (l) => {
            const i = l.shiftKey ? R.Shift : R.Default;
            let d = t;
            switch (l.code) {
              case "ArrowUp":
              case "ArrowRight":
                d += i * e.keyboardStep * e.step, d = U(
                  d,
                  e.min,
                  e.max,
                  e.step
                );
                break;
              case "ArrowDown":
              case "ArrowLeft":
                d -= i * e.keyboardStep * e.step, d = U(
                  d,
                  e.min,
                  e.max,
                  e.step
                );
                break;
              default:
                return;
            }
            l.preventDefault(), T(d, "keyboard");
          },
          mousedown: z,
          touchstart: z
        },
        style: {
          left: V(t, e.min, e.max)
        }
      };
    }));
    function C(t) {
      if (t.preventDefault(), e.disabled || !b.value)
        return;
      const { left: a, width: r } = b.value.getBoundingClientRect(), o = F(
        t,
        a,
        r,
        e.min,
        e.max,
        e.step
      );
      let v;
      if (e.modelValue[0] === e.modelValue[1])
        v = o > e.modelValue[0] ? 1 : 0;
      else {
        const f = e.modelValue.map((u) => Math.abs(u - o));
        v = f.findIndex((u) => u === Math.min(...f));
      }
      h(P(e.modelValue, v, o)), m.value[v]?.dispatchEvent(new Event("mousedown"));
      try {
        m.value[v]?.dispatchEvent(new TouchEvent("touchstart"));
      } catch {
      }
    }
    const L = n`rounded-sm border-2`, G = [
      L,
      n`border-static-default-low w-full cursor-pointer disabled:cursor-not-allowed`
    ], J = s(() => [
      L,
      n`border-static-default-hi pointer-events-none absolute`,
      e.disabled && n`hidden`
    ]), D = s(() => [
      n`bg-action-default-low rounded-md absolute top-1/2 -translate-x-1/2 -translate-y-1/2`,
      n`after:rounded-md after:absolute after:left-1/2 after:top-1/2 after:size-4 after:-translate-x-1/2 after:-translate-y-1/2 after:bg-current after:content-['']`
    ]), O = s(() => [
      D.value,
      n`pointer-events-none z-[1] size-12`,
      e.disabled && n`bg-action-default-low-disabled text-action-default-low-disabled`
    ]), Q = s(() => [
      D.value,
      n`z-10 size-28 border`,
      e.disabled ? n`border-action-default-hi-disabled pointer-events-none cursor-not-allowed before:bg-action-default-low-disabled before:rounded-sm after:text-onaction-default-low-disabled before:absolute before:inset-0` : n`border-action-default-hi focus-visible-outline-default-hi cursor-pointer after:text-onaction-default-low hover:bg-action-default-low-hover hover:shadow-long`
    ]);
    return (t, a) => (w(), p("div", {
      class: y(["isolate px-16 lg:px-14", t.$attrs.class]),
      style: k(t.$attrs.style)
    }, [
      g("div", oe, [
        g("button", {
          ref_key: "track",
          ref: b,
          "aria-hidden": "",
          class: y(G),
          disabled: c.disabled,
          tabindex: "-1",
          variant: "primary",
          onMousedown: C,
          onTouchstart: C
        }, null, 40, se),
        g("div", {
          class: y(J.value),
          "data-test": "sliderbase-selection",
          style: k(K.value)
        }, null, 6),
        c.showSteps ? (w(!0), p(N, { key: 0 }, A(S.value, (r, o) => (w(), p("span", {
          key: r,
          "aria-hidden": "",
          class: y(O.value),
          role: "presentation",
          style: k(W.value[o])
        }, null, 6))), 128)) : Z("", !0),
        (w(!0), p(N, null, A(q.value, (r, o) => (w(), p("span", M({
          key: o,
          ref_for: !0,
          ref_key: "thumbs",
          ref: m,
          "aria-disabled": c.disabled,
          "aria-label": c.label[o],
          "aria-orientation": "horizontal",
          "aria-valuemax": c.max,
          "aria-valuemin": c.min,
          "aria-valuenow": c.modelValue[o],
          class: Q.value,
          role: "slider",
          style: r.style,
          tabindex: _.value
        }, ee(r.listeners, !0)), null, 16, ne))), 128)),
        g("input", M(H.value, {
          type: "hidden",
          value: I.value
        }), null, 16, re)
      ])
    ], 6));
  }
});
export {
  be as default
};
